import { Injectable } from "@angular/core";
import { HttpInterceptor, HTTP_INTERCEPTORS, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpResponseBase, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ShareService } from "../../shared/service/share.service";
import { MatDialog } from "@angular/material/dialog";
import { LoaderService } from "../../shared/loader/loader.service";
import { StorageService } from "../../Service/storage.service";
import { AuthService } from "./auth.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  readonly TOKEN_HEADER: string = "Authorization";
  token: string;
  matchUrl: any;
  ipAddress: string;
  domainUrl: string;
  constructor(
    public shareservice: ShareService,
    private loaderservice: LoaderService,
    private readonly dialogRef: MatDialog,
    private readonly storageService: StorageService,
    private readonly authService: AuthService

  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.domainUrl = window.location.host == "localhost" ? this.storageService.getItem("MobileDomain") : window.location.host;
    this.ipAddress = this.storageService.getItem("IA");
    this.token = this.storageService.getItem("token");
    const locationStorage = this.storageService.getItem("Location");
    let locationData = locationStorage ? JSON.parse(locationStorage) : {};
    let locationId = locationData.Id ?? locationData.id ?? 1;
    const httpHeaders = new HttpHeaders({
      Authorization: "Bearer " + this.token,
      "X-Forwarded-For": `${this.ipAddress}`,
      RequestUrl: this.domainUrl
    });
    var matchurl = window.location.hash;
    if (
      (!matchurl.includes("Redirect") &&
        window.location.hash != "#/" &&
        !matchurl.includes("WelcomeWindow") &&
        !matchurl.includes("forgot") &&
        !matchurl.includes("ForgetPasswordEmailVerification") &&
        !matchurl.includes("OTPVerification") &&
        !matchurl.includes("EmailVerification")) ||
      !!this.token
    ) {
      req = req.clone({
        headers: httpHeaders,
        setParams: {
          locationId: (locationId),
        },
      });
    } else {
      if (!!this.ipAddress) {
        req = req.clone({
          headers: new HttpHeaders({ "X-Forwarded-For": this.ipAddress, RequestUrl: this.domainUrl }),
        });
      }
      else {
        if (!req.url.includes('api64.ipify.org'))
          req = req.clone({
            headers: new HttpHeaders({ RequestUrl: this.domainUrl }),
          });
      }
    }

    return next
      .handle(req)
      .pipe(
        tap(
          this.onSubscribeSuccess.bind(this),
          this.onSubscribeError.bind(this)
        )
      );
  }

  private onSubscribeSuccess(res: HttpEvent<any>) {
    if (res instanceof HttpResponse) {
      this.updateTokenFromResponse(res);
    }
  }

  updateTokenFromResponse(res: HttpResponseBase) {
    const headerName = this.TOKEN_HEADER;
    if (res.headers && res.headers.has(headerName)) {
      this.storageService.setItem("token", res.headers.get(headerName));
    }
  }

  private onSubscribeError(error: HttpEvent<any>) {
    if (!(error instanceof HttpErrorResponse)) {
      return;
    }
    if (error.status === 403) {
      if (this.authService.isInOnboarding()) return;
      this.loaderservice.hide();
      this.shareservice.showToast(error.error.Message, "Error");
      // this.dialogRef.closeAll();

      var matchurl = window.location.hash;
      if (
        window.location.hash != "#/" &&
        window.location.hash != "" &&
        !matchurl.includes("Redirect") &&
        !matchurl.includes("WelcomeWindow") &&
        !matchurl.includes("forgot") &&
        !matchurl.includes("ForgetPasswordEmailVerification") &&
        !matchurl.includes("OTPVerification") &&
        !matchurl.includes("EmailVerification")
      ) {
        setTimeout(() => {
          window.location.href = "";
          this.storageService.clear();
        }, 200);
      }
    }

    const handlerName = "handleError" + error.status;
    if (typeof this[handlerName] === "function") {
      return this[handlerName](error);
    }

    this.updateTokenFromResponse(error);
  }

  handleError401(error: HttpErrorResponse) {
    if (this.authService.isInOnboarding()) {
      return;
    }
    this.shareservice.showToast("Session expired!", "Error");
    this.loaderservice.hide();
    this.dialogRef.closeAll();
    this.storageService.clear();
    setTimeout(() => {
      window.location.href = "";
    }, 300);
  }
}

export const tokenInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true,
};
